import _ from "lodash-es";

export function getWorkplaceTrackStatus(value) {

	let id = '';

	if (
		value.manufacturingScheduleTrackers.length == 0
	) {
		id = 'Waiting'
	} else if (
		value.finished == false
	) {
		id = 'InProgress'
	} else {
		id = 'Done'
	}

	return _.find(
		workplaceTrackStatus,
		item => {
			return item.id == id;
		},
		0
	);
}

export function getCommandStatus(value) {
	return _.find(
		commandStatus,
		item => {
			return item.id == value.manufacturingCommandStatus;
		},
		0
	);
}

const workplaceTrackStatus = [{
		id: "Waiting",
		name: "Čaká",
		tooltip: "Čaká na spracovanie",
		icon: "mdi-circle-outline",
		color: "primary",
	},
	{
		id: "InProgress",
		name: "Prebieha",
		tooltip: "Prebieha",
		icon: "mdi-circle-slice-3",
		color: "warning",
	},
	{
		id: "Done",
		name: "Ukončená",
		tooltip: "Ukončená",
		icon: "mdi-circle-slice-8",
		color: "success",
	},
];

const commandStatus = [{
		id: "New",
		name: "Nová",
		tooltip: "Čaká na potvrdenie do výroby",
		icon: "mdi-new-box",
		color: "primary",
	},
	{
		id: "InProgress",
		name: "Vo výrobe",
		tooltip: "Vo výrobe / Vyrába sa",
		icon: "mdi-progress-wrench",
		color: "warning",
	},
	{
		id: "Done",
		name: "Ukončený",
		tooltip: "Výrobný príkaz sa ukončil",
		icon: "mdi-check",
		color: "success",
	},
	{
		id: "Canceled",
		name: "Zrešený",
		tooltip: "Výrobný príkaz sa zrušil",
		icon: "mdi-cancel",
		color: "error",
	},
];